import ViewApplication from "pages/BaseApplication/ViewApplication"
import React, { useEffect, useState } from "react"
import { Row } from "reactstrap"
import Licensing from "services/Licensing.service"

const user = JSON.parse(localStorage.getItem("authUser"))
let licensingService = new Licensing(user)

const BaselDetails = props => {
  const [wasteIds, setwasteIds] = useState()
  const [states, setstates] = useState()

  useEffect(() => {
    fetchWasteIds(props.appDetails.id)
    fetchTransitStates(props.appDetails.id)
  }, [])

  const fetchWasteIds = appId => {
    licensingService.getClientWasteIds(appId).then(response => {
      console.log(response)
      if (response.status) {
        const wastes = response.data.map((item, index) => {
          return (
            <tr key={index}>
              <td>{item.waste_identification.name}</td>
              <td>{item.code}</td>
            </tr>
          )
        })
        setwasteIds(wastes)
      }
    })
  }

  const fetchTransitStates = appId => {
    licensingService.getTransitStates(appId).then(response => {
      console.log(response)
      if (response.status) {
        const states = response.data.map((item, index) => {
          return (
            <tr key={index}>
              <td>{item.state_of_dispatch}</td>
              <td>{item.state_of_transit}</td>
              <td>{item.state_of_destination}</td>
            </tr>
          )
        })
        setstates(states)
      }
    })
  }
  return (
    <>
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Chemical Name</td>
              <td>{props.appDetails.basel_convention.chemicals_name}</td>
            </tr>

            <tr>
              <td>Registration Number</td>
              <td>{props.appDetails.basel_convention.registration_number}</td>
            </tr>

            <tr>
              <td>Notification Concerning</td>
              <td>
                {props.appDetails.basel_convention.notification_concern.name}
              </td>
            </tr>

            <tr>
              <td>Purpose</td>
              <td>{props.appDetails.basel_convention.basel_purpose.name}</td>
            </tr>

            <tr>
              <td>Pre-consented recovery facility</td>
              <td>{props.appDetails.basel_convention.is_recovery}</td>
            </tr>

            <tr>
              <td>Total intended number of shipments</td>
              <td>{props.appDetails.basel_convention.number_of_shipments}</td>
            </tr>

            <tr>
              <td>Total intended quantity</td>
              <td>{props.appDetails.basel_convention.quantity}</td>
            </tr>

            <tr>
              <td>Quantity measure</td>
              <td>{props.appDetails.basel_convention.quantity_measure.name}</td>
            </tr>

            <tr>
              <td>First Departure</td>
              <td>{props.appDetails.basel_convention.first_departure}</td>
            </tr>

            <tr>
              <td>Last Departure</td>
              <td>{props.appDetails.basel_convention.last_departure}</td>
            </tr>

            <tr>
              <td>Packaging Type</td>
              <td>{props.appDetails.basel_convention.packaging_types}</td>
            </tr>

            <tr>
              <td>Special handling requirements</td>
              <td>
                {
                  props.appDetails.basel_convention
                    .special_handling_requirements
                }
              </td>
            </tr>

            <tr>
              <td>Designation and composition of the waste</td>
              <td>{props.appDetails.basel_convention.composition_of_waste}</td>
            </tr>

            <tr>
              <td>Physical characteristic</td>
              <td>
                {props.appDetails.basel_convention.physical_characteristics}
              </td>
            </tr>

            <tr>
              <td colSpan={2}>Intended Carriers</td>
            </tr>

            <tr>
              <td>Registration Number</td>
              <td>
                {props.appDetails.basel_convention.notification_concern.name}
              </td>
            </tr>

            <tr>
              <td>Name</td>
              <td>{props.appDetails.basel_convention.carrier_name}</td>
            </tr>

            <tr>
              <td>Address</td>
              <td>{props.appDetails.basel_convention.carrier_address}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{props.appDetails.basel_convention.contact_person_email}</td>
            </tr>
            <tr>
              <td>Contact Person</td>
              <td>{props.appDetails.basel_convention.contact_person}</td>
            </tr>

            <tr>
              <td>Means of Transport</td>
              <td>{props.appDetails.basel_convention.means_of_transport}</td>
            </tr>

            <tr>
              <td colSpan={2}>Disposal/Recovery Operation(s)</td>
            </tr>

            <tr>
              <td>D-code / R-code</td>
              <td>{props.appDetails.basel_convention.discovery_code}</td>
            </tr>

            <tr>
              <td>Technology employed</td>
              <td>{props.appDetails.basel_convention.technology_employed}</td>
            </tr>

            <tr>
              <td>Reason for Export</td>
              <td>{props.appDetails.basel_convention.reason}</td>
            </tr>
          </tbody>
        </table>

        <h5>Waste Identifications</h5>
        <table className="table table-responsive table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
            </tr>
          </thead>
          <tbody>{wasteIds}</tbody>
        </table>

        <h5>Transit States</h5>
        <table className="table table-responsive table-striped">
          <thead>
            <tr>
              <th>Dispatch</th>
              <th>Transit</th>
              <th>Destination</th>
            </tr>
          </thead>
          <tbody>{states}</tbody>
        </table>
      </Row>
    </>
  )
}

export default BaselDetails
